class SectionThree {
  constructor () {
    this.oCanvas = null
    this.$canvas = document.getElementById('waterWaves')
    this.simplex = null
    this.waterWavsObj = {}
    this.$imgLists = $('.imgLists')
    this.aImages = []
    
    this.init()
  }
  
  init () {
    //  water wave handler
    this._waterWaveHandler()
    //  iphone lists handler
    this._iphoneListsHandler()
  }
  
  /**
   * 处理图片列表
   * @private
   */
  _iphoneListsHandler () {
    let images = []
    this.$imgLists.children().map((k, el) => images.push(el.dataset.img))
    this.$imgLists.html('')
    
    //  遍历添加图片
    images.map((link, key) => {
      if (key !== 2) {
        let img = $(`<img src="${link}?random=${window.randomString}" data-index="${key}" class="abs" />`)
        this.aImages.push(img)
        this.$imgLists.append(img)
      } else {
        let poster = link.replace('.mp4', '.jpg')
        let disableAutoplay = window.innerWidth < window.breakPoints.tablet ? `controls poster="${poster}"` : 'autoplay controls'
  
        if (window.isSamsungBrowser) {
          this.$imgLists.append(`<div class="iphone"><img class="iphone--image" src="${poster}" /></div>`)
        } else {
          this.$imgLists.append(`<div class="iphone"><div class="iphoneVideo"><video ${disableAutoplay} width="100%" preload="auto" autoplay muted loop playsinline data-setup="{}" src="${link}?random=${window.randomString}"></video></div></div>`)
        }
        
      }
    })
    
    this._imagesLayout()
    $(window).resize(() => this._imagesLayout())
  }
  
  /**
   * 处理图片排版
   * @private
   */
  _imagesLayout () {
    let iphoneWidth = this.$imgLists.find('.iphoneVideo').outerWidth()
    let Threshold = -30
    this.aImages.map((el, key) => {
      if (key === 0) {
        $(el).width(iphoneWidth + (2 * Threshold))
      } else if (key === 1) {
        $(el).width(iphoneWidth + (1 * Threshold))
      } else if (key === 2) {
        $(el).width(iphoneWidth + (1 * Threshold))
      } else {
        $(el).width(iphoneWidth + (2 * Threshold))
      }
    })
  }
  
  /**
   * 处理水波纹背景
   * @private
   */
  _waterWaveHandler () {
    this.oCanvas = this.$canvas.getContext('2d')
    this.simplex = new SimplexNoise()
    $(window).resize(() => this._waterWaveResize())
    this._waterWaveResize()
    this._waterWaveLoop()
  }
  
  /**
   * generator
   * @private
   */
  _wave () {
    this.oCanvas.beginPath()
    let sway = this.simplex.noise2D(this.waterWavsObj.goff, 0) * this.waterWavsObj.amp
    for (let i = 0 ; i <= this.waterWavsObj.count ; i++) {
      this.waterWavsObj.xoff += this.waterWavsObj.xinc
      let x = this.waterWavsObj.cx - this.waterWavsObj.length / 2 + (this.waterWavsObj.length / this.waterWavsObj.count) * i
      let y = this.waterWavsObj.y + this.simplex.noise2D(this.waterWavsObj.xoff, this.waterWavsObj.yoff) * this.waterWavsObj.amp + sway
      this.oCanvas[i === 0 ? 'moveTo' : 'lineTo'](x, y)
    }
    this.oCanvas.lineTo(this.waterWavsObj.w, this.waterWavsObj.h)
    this.oCanvas.lineTo(0, this.waterWavsObj.h)
    this.oCanvas.closePath()
    this.oCanvas.fillStyle = 'rgba(220,231,251,0.5)'
    this.oCanvas.fill()
  }
  
  /**
   * paint
   * @private
   */
  _waterWaveLoop () {
    requestAnimationFrame(this._waterWaveLoop.bind(this))
    this.oCanvas.clearRect(0, 0, this.waterWavsObj.w, this.waterWavsObj.h)
    this.waterWavsObj.xoff = 0
    this._wave()
    this._wave()
    this._wave()
    this._wave()
    this.waterWavsObj.yoff += this.waterWavsObj.yinc
    this.waterWavsObj.goff += this.waterWavsObj.ginc
  }
  
  /**
   * resize event handler
   * @private
   */
  _waterWaveResize () {
    this.waterWavsObj.w = window.innerWidth
    this.waterWavsObj.h = 400
    this.waterWavsObj.cx = this.waterWavsObj.w / 2
    this.waterWavsObj.cy = this.waterWavsObj.h / 2
    this.$canvas.width = this.waterWavsObj.w
    this.$canvas.height = this.waterWavsObj.h
    
    this.waterWavsObj.count = Math.floor(this.waterWavsObj.w / 30)  //  波峰
    this.waterWavsObj.xoff = 0
    this.waterWavsObj.xinc = 0.05
    this.waterWavsObj.yoff = 0
    this.waterWavsObj.yinc = 0.003
    this.waterWavsObj.goff = 0
    this.waterWavsObj.ginc = 0.003
    this.waterWavsObj.y = this.waterWavsObj.h * 0.86
    this.waterWavsObj.length = this.waterWavsObj.w + 10
    this.waterWavsObj.amp = 60
  }
  
}

export default SectionThree
